<div class="flex flex-row gap-3" style="overflow: scroll;" *ngIf="checkCaricamentoLuoghi">
  <app-input-select-luogo-area class="flex-grow-1 "  [form]="form" name="regioni" [allData]="datiRegione" [datiSelezionati]="luogoRegioniSignal" [deleghe]="delegheRegioni" [canAdd]="false"></app-input-select-luogo-area>
   <app-input-select-luogo-area  class="flex-grow-1 " [form]="form" name="comuni" [allData]="datiComune" [datiSelezionati]="luogoComuniSignal" [deleghe]="delegheComuni"  [canAdd]="false"></app-input-select-luogo-area>  
</div>


